// extracted by mini-css-extract-plugin
module.exports =  {"header":"adQUlgpJ","subheading":"qMUDLBy2","footer":"OU9RFitD","uninstallButton":"aY5uxcLy","rightHandButtonContainer":"M9vtQfaq"};